var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85783 1.57349C9.85783 1.25676 10.1146 1 10.4313 1C10.7481 1 11.0048 1.25676 11.0048 1.57349V22.2398C11.0048 22.5565 10.7481 22.8133 10.4313 22.8133C10.1146 22.8133 9.85783 22.5565 9.85783 22.2398V1.57349Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.40723L11.0048 10.4831L11.0048 2.33133L21 6.40723Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8627 22.8133C16.8627 23.3562 13.9832 23.7964 10.4313 23.7964C6.8794 23.7964 4 23.3562 4 22.8133C4 22.2703 6.8794 21.8301 10.4313 21.8301C13.9832 21.8301 16.8627 22.2703 16.8627 22.8133Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishicon);
export default __webpack_public_path__ + "static/media/finish.icon.796a9ee89fdf8e8fa4b1b7256a1ca184.svg";
export { ForwardRef as ReactComponent };